import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules  } from '@angular/router'; 
import { PagesComponent } from './pages/pages.component';
import { BlankComponent } from './pages/blank/blank.component';
import { SearchComponent } from './pages/search/search.component';
import { NotFoundComponent } from './pages/errors/not-found/not-found.component';
import { GetQuoteComponent } from './pages/getquote/getquote.component';
import { BookingComponent } from './pages/booking/booking.component';
import { BookService } from 'src/app/services/book.services';

import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AutoCompleteModule } from 'angular-ngx-autocomplete';
import { NgxLoadingModule } from 'ngx-loading';


export const routes: Routes = [
  {
    path: '', 
    component: PagesComponent, 
    children:[
      { path: '', component: GetQuoteComponent },
      { path: 'booking', component: BookingComponent }, // Added route for empty booking
      { path: 'booking/:quote_id',  component: BookingComponent },
      { path: 'blank', component: BlankComponent, data: { breadcrumb: 'Blank page' } },
      { path: 'search', component: SearchComponent, data: { breadcrumb: 'Search' } }
    ]
  },

  // { path: 'login', loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule) },
  // { path: 'register', loadChildren: () => import('./pages/register/register.module').then(m => m.RegisterModule) },
  // { path: 'blank', component: BlankComponent, data: { breadcrumb: 'Blank page' } },
  // { path: 'search', component: SearchComponent, data: { breadcrumb: 'Search' } },
  

  { path: '**', component: NotFoundComponent }
]; 

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules, // <- comment this line for activate lazy load
      relativeLinkResolution: 'legacy',
      // useHash: true
    })
  ],
  exports: [
    RouterModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    AutoCompleteModule,
    NgxLoadingModule,
  ],
  providers: [
    BookService
  ]
})
export class AppRoutingModule { }